export const generatePaginatedUrl = ({
  currentPage,
  nextPage,
  asPath,
}: {
  currentPage: number;
  nextPage: number;
  asPath: string;
}) => {
  if (nextPage <= 1) {
    return asPath.replace(`?page=${currentPage}`, '').replace(`&page=${currentPage}`, '');
  }

  if (currentPage > 1) {
    return asPath.replace(`page=${currentPage}`, `page=${nextPage}`);
  }

  return `${asPath}${asPath.includes('?') ? '&' : '?'}page=${nextPage}`;
};
